var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsbx: "https://boxy-svg.com",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    bxorigin: "-0.26123 0.490088",
    fill: "#00832d",
    d: "m13.576 12.023 2.339 2.674 3.146 2.01.548-4.667-.548-4.564-3.206 1.766-2.279 2.781Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "1.861908 -0.535454",
    fill: "#0066da",
    d: "M0 16.274v3.977c0 .909.736 1.645 1.646 1.645h3.976l.823-3.006-.823-2.616-2.729-.823L0 16.274Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "1.865962 1.528316",
    fill: "#e94235",
    d: "M5.622 2.15 0 7.772l2.893.823 2.729-.823.809-2.581-.809-3.041Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "2.134472 0.497295",
    fill: "#2684fc",
    d: "M5.622 7.772H0v8.502h5.622V7.772Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.347045 0.436238",
    fill: "#00ac47",
    d: "m22.653 4.531-3.592 2.945v9.231l3.609 2.96c.54.422 1.33.037 1.33-.65V5.167c0-.695-.808-1.077-1.347-.636Zm-9.077 7.492v4.251H5.622v5.622h11.793c.909 0 1.646-.736 1.646-1.645v-3.544l-5.485-4.684Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    bxorigin: "0.474589 0.99767",
    fill: "#ffba00",
    d: "M17.415 2.15H5.622v5.622h7.954v4.251l5.485-4.544V3.796c0-.91-.737-1.646-1.646-1.646Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google_meet.b99dd80f273b96b8c273c7fcf8309e2c.svg";
export { ForwardRef as ReactComponent };